import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { replaceLink } from 'shared/lib'
import { type ActionItem } from 'shared/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { ShortLinkDropdownItem } from 'entities/ShortLink'
import { IAIActionTypeEnum } from 'entities/AIAssistant'
import {
  EmojiAction,
  type MessageFieldStore,
  SavedRepliesAction,
  ShortenLinkAction,
} from 'widgets/MessageField'
import { MediaAction } from 'widgets/MessageField/ui/FieldActions/MediaAction/MediaAction'
import { type SavedRepliesStore } from 'widgets/SavedReplies'
import { AIAssistantAction, AiAssistantStore } from 'widgets/AIAssistant'

export class SurveyMessageActionsStore {
  readonly aiAssistantStore: AiAssistantStore
  private readonly _isDisabledAI = { value: true }
  private _disposeAIDisabled: IReactionDisposer | null = null

  constructor(
    private _messageFieldStore: MessageFieldStore,
    private _savedRepliesStore: SavedRepliesStore,
    private _entities: IEntitiesStore
  ) {
    this.aiAssistantStore = new AiAssistantStore(
      this._messageFieldStore,
      {
        actions: [
          IAIActionTypeEnum.Rephrase,
          IAIActionTypeEnum.MoreFriendly,
          IAIActionTypeEnum.MoreFormal,
          IAIActionTypeEnum.Expand,
          IAIActionTypeEnum.Shorten,
        ],
      },
      this._entities
    )

    makeAutoObservable(this)

    this._reactionAIDisabled()
  }

  get actions(): ActionItem[] {
    return [
      { iconButtonComponent: <MediaAction /> },
      { iconButtonComponent: <SavedRepliesAction store={this._savedRepliesStore} useHotKey /> },
      { iconButtonComponent: <EmojiAction /> },
      {
        iconButtonComponent: (
          <AIAssistantAction
            aiAssistantStore={this.aiAssistantStore}
            placementMainContent={'bottom-start'}
            isDisabledObj={this._isDisabledAI}
          />
        ),
      },
      {
        iconButtonComponent: <ShortenLinkAction />,
        dropdownItemComponent: (onCloseMenu) => (
          <ShortLinkDropdownItem
            onOpenModal={() => {
              const messageInnerText = this._messageFieldStore.messageInnerText
              this._entities.shortLinkStore.setMessageText(messageInnerText)
            }}
            onAddShortLink={(link) => {
              this._messageFieldStore.addContent &&
                this._messageFieldStore.addContent(replaceLink(link) + '&nbsp;')
            }}
            onCloseMenu={onCloseMenu}
          />
        ),
      },
    ]
  }

  dispose = () => {
    this._disposeAIDisabled?.()
    this.aiAssistantStore.dispose()
  }

  private _reactionAIDisabled = () => {
    this._disposeAIDisabled = reaction(
      () => this._messageFieldStore.messageInnerText,
      (text) => {
        this._isDisabledAI.value = !text
      },
      { fireImmediately: true }
    )
  }
}
